import {CreditStatusVo} from '../../../common/shared/api/nicolas/vo/enums/CreditStatusVo.enum';
import {KakaoCashReportDataVo} from '../../../common/shared/api/nicolas/vo/KakaoCashReportDataVo.interface';
import {ExtraLabelType} from '../../../graphql/generated/types';

export function getCashChargingExtraLabel(
  cash: KakaoCashReportDataVo
): ExtraLabelType | undefined {
  switch (cash.credit_status) {
    case CreditStatusVo.CancelCharge:
    case CreditStatusVo.Refund: {
      return ExtraLabelType.CancelCharge;
    }
    case CreditStatusVo.WithdrawEventCash: {
      return ExtraLabelType.Expired;
    }
    case CreditStatusVo.WithdrawByAdmin: {
      return ExtraLabelType.WithdrawByAdmin;
    }
    case CreditStatusVo.ExtinctCash: {
      return ExtraLabelType.ExtinctCash;
    }
    case CreditStatusVo.CancelIAPMarket: {
      return ExtraLabelType.CancelIapMarket;
    }
    case CreditStatusVo.WithdrawByAdminPlayPoints: {
      return ExtraLabelType.WithdrawByAdminPlayPoints;
    }
    default: {
      return undefined;
    }
  }
}
